import { appointment, appointmentJoin } from '@fireflyhealth/api'

import { usePromise } from '~/shared/hooks/usePromise'

export const useInitAppointment = (id: string | number | undefined) =>
  usePromise(
    async () => {
      const [appointmentRes, sessionRes] = await Promise.all([
        appointment.retrieve({ id: Number(id) }),
        appointmentJoin.retrieve({ id: Number(id) }),
      ])
      return {
        appointment: appointmentRes.data,
        session: sessionRes.data,
      }
    },
    { initialLoading: true, error: 'Failed to load appointment' },
  )
